import { getRnbErrorCode } from 'shared'
import { LOG_LEVEL_WARN, LOG_TYPE_REQUEST, type LogType } from 'typings'

type LogRnbErrorCodeParams = {
  error: unknown
  url: string
  logger: (params: LogType) => void
}

/**
 * sendlog in useFetch runs before the response body is parsed, so it cannot see
 * the code. Logging here keeps fetcherWrapper's throw contract untouched.
 * No-ops when the error carries no code.
 */
export function logRnbErrorCode(params: LogRnbErrorCodeParams) {
  const { error, url, logger } = params

  const code = getRnbErrorCode(error)

  if (!code) return

  const { status } = error as { status?: number }

  logger({
    message: `RnB rejected the request with code ${code}`,
    metadata: {
      url,
      statusCode: status === undefined ? '' : String(status),
      errorCode: code,
    },
    level: LOG_LEVEL_WARN,
    type: LOG_TYPE_REQUEST,
  })
}
